"use strict";
import Scanner from "@/framework/scans";
export const ScannerModels = Scanner.scanner(require.context("@/", true, /.model.ts/));
